import { modelT } from "../../redux/features/ui/ui.types";

export const modelsChairs: modelT[] = [
  {
    img: "/images/assets/ClassicSofa/SofaPlus.png",
    label: "Hexley Chair",
    nameValueThreekit: "Hexley Chair",
    subcategory: "Accent Chairs",
  },
  {
    img: "/images/assets/ClassicSofa/Sofa.png",
    label: "Ada Chair",
    nameValueThreekit: "Ada Chair",
    subcategory: "Accent Chairs",
  },
  // {
  //     img: '/images/assets/ClassicSofa/LoftSofa.png',
  //     label: 'Ada Swivel Chair',
  //     nameValueThreekit: 'Ada Swivel Chair',
  // },
  {
    img: "/images/assets/ClassicSofa/Loveseat.png",
    label: "Watson Chair",
    nameValueThreekit: "Watson Chair",
    subcategory: "Accent Chairs",
  },
  {
    img: "/images/assets/ClassicSofa/ArmChair.png",
    label: "Watson Swivel Chair",
    nameValueThreekit: "Watson Swivel Chair",
    subcategory: "Accent Chairs",
  },
  {
    img: "/images/assets/ClassicSofa/CuddleChair.png",
    label: "Hexley Swivel Chair",
    nameValueThreekit: "Hexley Swivel Chair",
    subcategory: "Accent Chairs",
  },
  {
    img: "/images/assets/ClassicSofa/Ottoman.png",
    label: "Zenon Chair",
    nameValueThreekit: "Zenon Chair",
    subcategory: "Accent Chairs",
  },
  {
    img: "/images/assets/ClassicSofa/CuddleOttoman.png",
    label: "Zenon Swivel Chair",
    nameValueThreekit: "Zenon Swivel Chair",
    subcategory: "Accent Chairs",
  },
  {
    img: "/images/assets/ClassicSofa/CuddleOttoman.png",
    label: "Popper Chair",
    nameValueThreekit: "Popper Chair",
    subcategory: "Accent Chairs",
  },
  {
    img: "/images/assets/ClassicSofa/CuddleOttoman.png",
    label: "Popper Swivel Chair",
    nameValueThreekit: "Popper Swivel Chair",
    subcategory: "Accent Chairs",
  },
  // {
  //     img: '/images/assets/ClassicSofa/CuddleOttoman.png',
  //     label: 'Crick Swivel Chair',
  //     nameValueThreekit: "Crick Swivel Chair",
  // },

  // Crick chair was removed from January 22 2025
  // {
  //   img: "/images/assets/ClassicSofa/CuddleOttoman.png",
  //   label: "Crick Chair",
  //   nameValueThreekit: "Crick Chair",
  //   subcategory: "Accent Chairs",
  // },
  {
    img: "/images/assets/ClassicSofa/CuddleOttoman.png",
    label: "Naomi Accent Chair",
    nameValueThreekit: "Naomi Accent Chair",
    subcategory: "Accent Chairs",
  },
  {
    img: "/images/assets/ClassicSofa/CuddleOttoman.png",
    label: "Sofie Accent Chair",
    nameValueThreekit: "Sofie Accent Chair",
    subcategory: "Accent Chairs",
  },
];
